import React from 'react';
import { arrayMove } from 'react-sortable-hoc';

import Tag from 'jbc-front/components/Tag';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import ActionButton from 'jbc-front/components/ActionButton';
import { MinusCircle, Strage } from 'jbc-front/components/icons';

import { CLIENT_SETTINGS, CLIENT_PAYROLL_RULES_GROUP_LIST, CLIENT_ALLOWANCES_LIST } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';
import { withTranslation } from 'react-i18next';

import SortableAllowancesTable from '../components/SortableAllowancesTable';

import styles from './ChangeAllowanceDisplayOrder.scss';

const allowancesUrl = payrollGroupId =>
  concatParamsToUrl(CLIENT_ALLOWANCES_LIST, { payrollRulesGroupId: payrollGroupId });

const SelectAllowanceType = ({ allowanceTypes, selectedAllowanceType, handleOnClick }) => (
  <div className={styles.filter}>
    {allowanceTypes.map(allowanceType => (
      <Tag
        key={allowanceType.value}
        active={allowanceType.value === selectedAllowanceType}
        onClick={e => {
          e.preventDefault();
          handleOnClick(allowanceType);
        }}
      >
        {allowanceType.label}
      </Tag>
    ))}
  </div>
);

// 支給/控除項目並び替え画面TOP
export class ChangeAllowanceDisplayOrderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnSelectAllowanceType = this.handleOnSelectAllowanceType.bind(this);
    this.getDisplayAllowances = this.getDisplayAllowances.bind(this);
    this.prepareDisplayAllowances = this.prepareDisplayAllowances.bind(this);
    this.state = {
      // 現在選択中の支給/控除種別 default: 支給項目
      selectedAllowanceType: 'payment',
      displayAllowances: {
        // 支給項目(表示管理用)
        payment: [],
        // 控除項目項目(表示管理用)
        deduction: []
      }
    };
    // サーバーからレンダリングされた支給・控除項目を保存しておく
    // clientAllowancesはサーバでレンダリングされた支給/控除項目
    const { clientAllowances, setAllowances } = this.props;
    setAllowances(clientAllowances);
  }

  // 並び替え完了のイベントハンドラ
  onSortEnd = ({ oldIndex, newIndex }) => {
    const { setAllowances } = this.props;
    const currentList = this.getDisplayAllowances(this.state.selectedAllowanceType);
    this.state.displayAllowances[this.state.selectedAllowanceType] = arrayMove([...currentList], oldIndex, newIndex);
    // 支給項目, 控除項目の順で保存する
    setAllowances([...this.state.displayAllowances.payment, ...this.state.displayAllowances.deduction]);
  };

  // 表示用の支給控除項目を取得する
  getDisplayAllowances(currentType) {
    return this.state.displayAllowances[currentType];
  }

  // 支給項目・控除項目の切り替えイベントのハンドラ
  handleOnSelectAllowanceType(allowanceType) {
    this.setState({
      ...this.state,
      selectedAllowanceType: allowanceType.value
    });
  }

  // 支給控除項目を支給と控除のリストに分割する
  prepareDisplayAllowances() {
    const { internalAllowances } = this.props;
    this.state.displayAllowances.payment = internalAllowances.filter(
      allowance => allowance.allowanceType === 'payment'
    );
    this.state.displayAllowances.deduction = internalAllowances.filter(
      allowance => allowance.allowanceType === 'deduction'
    );
  }

  render() {
    const { allowanceTypes, payrollRulesGroup, saveDisplayOrder, t } = this.props;
    const payrollRulesGroupId = payrollRulesGroup.id;
    this.prepareDisplayAllowances();
    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{t('features.ClientAllowances.components.ChangeAllowanceDisplayOrder.provision_deduction_item_sorting')}</h1>
          <div className="m-title-main-note">{payrollRulesGroup.name}</div>
        </div>
        <div className="l-wrap-s l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={t('features.ClientAllowances.components.ChangeAllowanceDisplayOrder.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={t('features.ClientAllowances.components.ChangeAllowanceDisplayOrder.salary_rule_group_list')} path={CLIENT_PAYROLL_RULES_GROUP_LIST} />
              <BreadCrumb.Item label={t('features.ClientAllowances.components.ChangeAllowanceDisplayOrder.provision_deduction_item_sorting')} />
            </BreadCrumb>
          </div>
          <div className={styles.head}>
            <div>
              <SelectAllowanceType
                allowanceTypes={allowanceTypes}
                selectedAllowanceType={this.state.selectedAllowanceType}
                handleOnClick={this.handleOnSelectAllowanceType}
              />
            </div>
            <div>
              <ActionButton onClick={saveDisplayOrder} icon={<Strage size={15} />}>
                {t('features.ClientAllowances.components.ChangeAllowanceDisplayOrder.save')}
              </ActionButton>
              <ActionButton
                className="u-ml10"
                as="a"
                href={allowancesUrl(payrollRulesGroupId)}
                icon={<MinusCircle size={15} />}
              >
                {t('features.ClientAllowances.components.ChangeAllowanceDisplayOrder.cancel')}
              </ActionButton>
            </div>
          </div>
          <SortableAllowancesTable
            onSortEnd={this.onSortEnd}
            allowances={this.getDisplayAllowances(this.state.selectedAllowanceType)}
            helperClass={styles.dragging}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ChangeAllowanceDisplayOrderComponent);
